// Add your own custom JS here.

var slideIndex = 0;
var slides = document.querySelectorAll(".announcement-utility-bar > div:not(#UtilityBar)");

document.addEventListener('DOMContentLoaded', function() {

  carousel();
  
  function toggleItem(anchorElement) {
    const dtElement = anchorElement.parentElement;
    const ddElement = dtElement.nextElementSibling;
    const toggleElement = anchorElement.querySelector('.faqs-component--toggle');

    if (!dtElement || !ddElement || !toggleElement) return;

    if (dtElement.classList.contains("faqs-component--selected")) {
      dtElement.classList.remove("faqs-component--selected");
      ddElement.classList.remove("faqs-component--selected");
      toggleElement.textContent = '+';
    } else {
      dtElement.classList.add("faqs-component--selected");
      ddElement.classList.add("faqs-component--selected");
      toggleElement.textContent = '-';
    }
  }

  const anchorElements = document.querySelectorAll('dl.faqs-component > dt > a');
  
  anchorElements.forEach(anchorElement => {
    const questionText = anchorElement.textContent;
    const questionSpan = document.createElement('span');
    questionSpan.className = 'faqs-component--question';
    questionSpan.textContent = questionText;

    const toggleSpan = document.createElement('span');
    toggleSpan.className = 'faqs-component--toggle';
    toggleSpan.textContent = '+';
    
    anchorElement.textContent = '';
    anchorElement.appendChild(questionSpan);
    anchorElement.appendChild(toggleSpan); 

    anchorElement.addEventListener('click', function(event) {
      event.preventDefault();
      toggleItem(anchorElement);
    });

    anchorElement.addEventListener('keydown', function(event) {
      if (event.code === 'Space') {
        event.preventDefault();
        toggleItem(anchorElement);
      }
    });
  });

  
},false);

function clearAnnouncements() {
  for (var i = 0; i < slides.length; i++) {
    slides[i].classList.remove("visible");
  }
}

function carousel() {
  clearAnnouncements();
  slideIndex++
  
  if (slideIndex > slides.length || slideIndex < 0) {
    slideIndex = 1;
  }
  
  slides[slideIndex-1].classList.add("visible");
  
  setTimeout(carousel, 3000); // Change announcement every 3 seconds
}
